
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Radio } from 'element-ui';
@Component({
  name: 'lb-radio'
  // components: {
  //   'el-radio': Radio
  // }
})
export default class extends Vue {
  @Prop() private value!: any;
  @Prop() private label!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop() private name!: string;

  private localValue = this.value || '';

  private handleClickLabel() {
    if (!this.disabled) {
      // @ts-ignore
      this.$refs.myRadio.$el.click();
    }
  }

  private handleRippleClick(e: any) {
    // @ts-ignore
    if (e.target.parentElement.className.indexOf('lb-ripple') > -1) {
      if (e.target.nextSibling && e.target.nextSibling.className.indexOf('el-radio') > -1) {
        e.target.nextSibling.click()
      }
    }
  }

  private handleChange(val: string) {
    this.$emit('change', val);
  }

  @Watch('value')
  private onValueChange(val: any) {
    this.localValue = val;
  }

  @Watch('localValue')
  private onLocalValueChange(val: any) {
    this.$emit('input', val);
  }
}
